import { defineStore } from 'pinia';

export const useAssetsModalStore = defineStore('assetsModal', {
  state: () => ({
    isOpen: false,
    resource: null,
    selected: null,
    parentType: null,
    assets: []  // Adding an assets array in the state
  }),
  getters: {
    // You can add getters if needed, for example, to check if there are any assets
    hasAssets: (state) => state.assets.length > 0
  },
  actions: {
    openDialog(newAssets, resource = 'photos', parentType, selected) {
      if (newAssets && Array.isArray(newAssets) && newAssets.length > 0) {
        this.assets = newAssets; // Set the new assets
        this.resource = resource;
        this.parentType = parentType;
        this.selected = selected;
        this.isOpen = true;      // Open the dialog
      }
    },
    closeDialog() {
      this.isOpen = false;
      this.assets = []; // Optionally clear assets when closing the dialog
    },
    setParentType(parentType) {
      this.parentType = parentType;
    },
    setResource(resource) {
      this.resource = resource;
    },
    setSelected(selected) {
      this.selected = selected;
    }
  }
});
